import React from 'react'
import './sidebar.css'
import SidebarOption from '../sidebarOption/SidebarOption'

function Sidebar() {
  return (
    <div  className='sidebarContener'>
        <SidebarOption title="Direct Messages" /> 
    </div>
  )
}

export default Sidebar